// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__HCtsh","location":"Header_location__1n2Bz"};